//@author: travis
import { TypeManagerDecorator } from "../../../main/type.map.service";
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewEncapsulation,
    signal,
} from "@angular/core";
import { S25TableModule } from "../../s25-table/s25.table.module";
import { Table } from "../../s25-table/Table";
import { GenericTableButtonComponent } from "../../s25-table/generics/generic.table.button.component";
import { Bind } from "../../../decorators/bind.decorator";
import { LynxStatus, S25LynxStatusService } from "./s25.lynx.status.service";

@TypeManagerDecorator("s25-ng-lynx-status")
@Component({
    selector: "s25-ng-lynx-status",
    template: `
        @if (this.init) {
            <span class="c-margin-left--single">System Health Monitor</span>
            <span class="aw-button">{{ status() }}</span>

            <s25-ng-table [columnSortable]="true" [hasRefresh]="true" [dataSource]="historyDataSource"></s25-ng-table>
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25TableModule],
})
export class S25LynxStatusComponent implements OnInit {
    init: boolean = false;

    //Status signal for easy updates
    status = signal<string>("");
    historyDataSource: Table.DataSource;

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
    ) {
        this.elementRef.nativeElement.angBridge = this;
    }

    async getAppStatus() {
        const resp = await S25LynxStatusService.getStatus();
        this.status.set(resp[0].clientStatusDesc);
        console.log("status", this.status, resp);
    }

    ngOnInit() {
        this.historyDataSource = {
            type: "unpaginated",
            dataSource: this.getRows,
            columns: [
                {
                    id: "message",
                    header: "Message",
                },
                {
                    id: "level",
                    header: "Level",
                },
                {
                    id: "lastUpdate",
                    header: "Last Updated",
                },
            ],
        };

        this.init = true;
        this.cd.detectChanges();
    }

    @Bind
    async getRows() {
        await this.getAppStatus();
        const history = await S25LynxStatusService.getHistory();

        console.log("history", history);
        return {
            rows: history.map(this.mapToRow) ?? [],
        };
    }

    @Bind
    mapToRow(message: LynxStatus.History): Table.Row {
        return {
            id: message.id,
            name: message.eventName,
            cells: {
                message: {
                    text: message.eventName,
                },
                level: {
                    text: message.eventLevel,
                },
                lastUpdate: {
                    text: message.lastModDtDisp,
                },
            },
        };
    }

    onLevelClick(message: Table.Row) {
        console.log("message", message);
        //TODO: open modal or navigate to state w/ details of this message or import
    }
}
